module.exports = __webpack_public_path__ + "img/eqip6.136999e1.png";